module.exports = __webpack_public_path__ + "static/media/member_03.b164cabe.jpg";